import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  CircularProgress,
  Typography,
} from '@material-ui/core'
import { useTrans } from '../../../services/i18n'

const PdfViewerModal = ({ open, onClose, form, downloadFormPdf }) => {
  const { trans } = useTrans()
  const [pdfData, setPdfData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleOpen = async () => {
    if (!form || !open) return

    setLoading(true)
    setError(null)
    setPdfData(null)

    try {
      const params = {
        formFields: form.partialSubmission,
        formStackId: form.formStackId,
        submissionId: form.formStackSubmissionId,
      }

      const response = await downloadFormPdf(params)
      
      if (response.payload?.pdfBase64) {
        setPdfData(response.payload.pdfBase64)
      } else {
        setError('Failed to load PDF')
      }
    } catch (err) {
      console.error('Error loading PDF:', err)
      setError('Failed to load PDF')
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if (open) {
      handleOpen()
    } else {
      setPdfData(null)
      setError(null)
    }
  }, [open])

  const handleClose = () => {
    setPdfData(null)
    setError(null)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: { height: '90vh' }
      }}
    >
      <DialogTitle>
        {trans('worksheet-response')} - {form?.formName || 'Worksheet'}
      </DialogTitle>
      
      <DialogContent style={{ padding: 0, display: 'flex', flexDirection: 'column' }}>
        {loading && (
          <Box display="flex" justifyContent="center" alignItems="center" height="400px">
            <CircularProgress />
            <Typography style={{ marginLeft: 16 }}>
              {trans('loading-pdf')}
            </Typography>
          </Box>
        )}
        
        {error && (
          <Box display="flex" justifyContent="center" alignItems="center" height="400px">
            <Typography color="error">{error}</Typography>
          </Box>
        )}
        
        {pdfData && !loading && (
          <iframe
            src={`data:application/pdf;base64,${pdfData}`}
            style={{
              width: '100%',
              height: '70vh',
              border: 'none',
            }}
            title="Worksheet PDF"
          />
        )}
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {trans('close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

PdfViewerModal.propTypes = {
  form: PropTypes.shape({
    formName: PropTypes.string,
    formStackId: PropTypes.string,
    formStackSubmissionId: PropTypes.string,
    partialSubmission: PropTypes.object,
  }),
}

export default PdfViewerModal